

if(document.getElementById('read-more-btn') != null){
  document.getElementById('read-more-btn').addEventListener('click', function() {
    var readMoreSection = document.querySelector('.read-more-section');
    if (readMoreSection.style.display === 'none' || readMoreSection.style.display === '') {
        readMoreSection.style.display = 'block';
        this.textContent = 'Show Less';
    } else {
        readMoreSection.style.display = 'none';
        this.textContent = 'Read More';
    }
});
}